import styles from './ProjectPerformers.module.css';

import settingsIcon from 'assets/svg/settings-01.svg';
import arrowIcon from 'assets/svg/arrow-01.svg';

import Icon from 'ui/Icon';
import Card from 'ui/Card';
import IconButton from 'ui/IconButton';
import { projectsStore } from 'store/mobx/projects.store';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import RegularButton from 'ui/RegularButton';
import classNames from 'classnames';
import { address_server_short } from '../../../../../config';

const MAX_VISIBLE_PERFORMERS_PREVIEW = 4;

const ProjectPerformers = observer(({ setModalOpened }) => {
  const { selectedProject } = projectsStore;
  const [expandPerformersPreview, setExpandPerformersPreview] = useState(false);
  const [projectPerformers, setProjectPerformers] = useState([]);

  useEffect(() => {
    if (!selectedProject?.users) return;
    const maxVisibleItems = selectedProject?.users?.slice(
      0,
      expandPerformersPreview ? selectedProject?.users.length : MAX_VISIBLE_PERFORMERS_PREVIEW,
    );
    setProjectPerformers(maxVisibleItems);
  }, [selectedProject?.users, expandPerformersPreview]);

  const handleEditPerformersClick = () => setModalOpened(true);

  const Performer = ({ key, performer }) => {
    return (
      <div className={styles.column} key={key}>
        <div className={styles.imageWrapper}>
          <img className={styles.image} src={address_server_short + performer.avatar} />
        </div>
        <div className={styles.performerDescription}>
          <div className={styles.performerTitle}>{performer.fio}</div>
          <div className={styles.performerSubtitle}>{performer.position}</div>
        </div>
      </div>
    );
  };

  return (
    <Card>
      <Card.Title text={'Исполнители'}>
        <IconButton tooltip={'Настройки'} icon={settingsIcon} onClick={handleEditPerformersClick} />
      </Card.Title>
      <Card.Content className={styles.performersInfo}>
        <div className={styles.gridPerformers}>
          {(projectPerformers?.length &&
            projectPerformers.map((performer) => (
              <Performer key={performer.id} performer={performer} />
            ))) || <div>Исполнители не добавлены</div>}
        </div>
        <RegularButton
          className={styles.expandButton}
          text={expandPerformersPreview ? 'Свернуть' : 'Развернуть'}
          variant={'outlined'}
          color={'secondary'}
          disabled={
            !projectPerformers?.length ||
            selectedProject?.users?.length <= MAX_VISIBLE_PERFORMERS_PREVIEW
          }
          onClick={() => setExpandPerformersPreview(!expandPerformersPreview)}
          appendIcon={
            <Icon
              className={classNames(styles.expandIcon, {
                [styles.expandedIcon]: expandPerformersPreview,
              })}
              color={'var(--color-secondary)'}
              src={arrowIcon}
              width={'14px'}
              height={'14px'}
            />
          }
        />
      </Card.Content>
    </Card>
  );
});

export default ProjectPerformers;
